import React from 'react';
import { Link } from 'gatsby';
import { useDarkMode } from 'usehooks-ts';
import styled from 'styled-components';
import parse from "html-react-parser";
import {motion} from "framer-motion";

// TODO: add floating squares

const StyledBanner = styled.div`
  .container {
    position: relative;
    padding-top: 10rem;
    padding-bottom: 10rem;
    min-height: 37rem;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
  }

  .banner-icon {
    display: block;
    max-height: 90px;
    margin: 1rem 0;
  }

  .banner-icon * {
    fill: ${({ darkMode }) => (darkMode ? '#fff' : 'var(--dark-navy)')};
  }

  :root.light {
    .banner-icon * {
      fill: var(--dark-navy);
    }
  }

  .title {
    font-size: var(--h1-size);
    max-width: 40rem;
    margin: 0;
    font-size: var(--h1-size);
  }

  .meta-label {
    margin: 0 0 1.5rem;
  }

  .meta-label-link {
    color: var(--text);
  }

  .floating-pixels {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -1;

    .floating-pixel {
      position: absolute;
    }

    .pixel-1 {
      top: 27%;
      right: 10vw;
      animation-delay: 0s;

      @media all and (min-width: 992px) {
        top: 40%;
        right: 10rem;
      }
    }

    .pixel-2 {
      top: 25%;
      right: 13rem;
      animation-delay: -1s;

      @media all and (min-width: 992px) {
        right: 23rem;
      }
    }

    .pixel-3 {
      top: 77%;
      right: 21rem;
      animation-delay: -2s;

      @media all and (min-width: 992px) {
        top: 67%;
      }
    }

    .pixel-4 {
      top: 27%;
      right: 34rem;
      animation-delay: -3s;
    }

    .pixel-5 {
      top: 52%;
      right: 42rem;
      animation-delay: -4s;

      @media (max-width: 1200px) {
        display: none;
      }
    }

    .pixel-6 {
      top: 73%;
      right: 55rem;
      animation-delay: -5s;

      @media (max-width: 1200px) {
        display: none;
      }
    }
  }

  .theme.light & {
    //todo light mode styles
  }
`;

export default function TitleBanner({
  title,
  sectionTitle,
  BannerIcon,
  sectionLink,
  classes = 'bg-blue-gradient bg-colored-squares',
}) {
  const bannerClass = `title-banner angled-bottom ${classes}`;
  let sectionMeta;
  if (sectionLink) {
    sectionMeta = (
      <Link className="meta-label-link" to={sectionLink}>
        <h6 className="meta-label">{sectionTitle}</h6>
      </Link>
    );
  } else {
    sectionMeta = <h6 className="meta-label">{sectionTitle}</h6>;
  }
  const { isDarkMode } = useDarkMode();
  return (

    <StyledBanner darkMode={isDarkMode} className={bannerClass}>
      <div className="container padding-x-12">
        <motion.div
          key="title"
          initial={{ opacity: 0, x: 0, y: -400, rotate: 0 }}
          animate={{ opacity: 1, x: 0, y: 0, rotate: 0 }}
          transition={{
            type: "spring",
            mass: 0.15,
            stiffness: 65,
          }}
        >
          {sectionMeta}
          <h1 className="title">{parse(title)}</h1>
          {BannerIcon && <BannerIcon className="banner-icon" />}
        </motion.div>

        <div className="floating-pixels">
          <div className="pixel-1 floating-pixel floating-pixel--xl floating-pixel--rotate-30"></div>
          <div className="pixel-2 floating-pixel floating-pixel--xxs floating-pixel--red floating-pixel--opacity-70"></div>
          <div className="pixel-3 floating-pixel floating-pixel--xs floating-pixel--red floating-pixel--rotate-67"></div>
          <div className="pixel-4 floating-pixel floating-pixel--md floating-pixel--rotate-26"></div>
          <div className="pixel-5 floating-pixel floating-pixel--sm floating-pixel--red floating-pixel--rotate-50"></div>
          <div className="pixel-6 floating-pixel floating-pixel--md floating-pixel--red floating-pixel--rotate-26"></div>
        </div>
      </div>
    </StyledBanner>
  );
}
